import { render } from "./ServicesPage.vue?vue&type=template&id=1ee2bf88"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__